import React from 'react';
import { Popover, theme } from 'antd';
import { observer } from 'mobx-react';
import { toUpper } from 'lodash';
import { useTranslation } from 'react-i18next';

import { getIcon, getPopoverContent, MessageSeverityLevels } from './ControlIcon.utils';

const { useToken } = theme;

export const ControlIcon = observer(({ connectivity, controlMode, messages, ...rest }) => {
  const { t } = useTranslation();
  const { token } = useToken();
  const messagesWithNumericalSeverity = messages?.map(m => {
    const messageWithNumericalSeverity = { ...m };
    switch (toUpper(m.severity)) {
      case 'INFO':
        messageWithNumericalSeverity.severityLevel = MessageSeverityLevels.Info;
        break;
      case 'WARNING':
        messageWithNumericalSeverity.severityLevel = MessageSeverityLevels.Warning;
        break;
      case 'ERROR':
        messageWithNumericalSeverity.severityLevel = MessageSeverityLevels.Error;
        break;
      default:
        messageWithNumericalSeverity.severityLevel = MessageSeverityLevels.Default;
        break;
    }
    return messageWithNumericalSeverity;
  });

  const selectedMessage = {
    text: null,
    severityLevel: null,
  };

  if (messagesWithNumericalSeverity) {
    messagesWithNumericalSeverity.forEach(message => {
      if (selectedMessage.severityLevel && message.severityLevel > selectedMessage.severityLevel) {
        selectedMessage.severityLevel = message.severityLevel;
        selectedMessage.text = message.text;
      } else if (!selectedMessage.severityLevel) {
        selectedMessage.severityLevel = message.severityLevel;
        selectedMessage.text = message.text;
      }
    });
  }

  const popoverContent = getPopoverContent(connectivity, selectedMessage, controlMode, t);
  const icon = getIcon(connectivity, controlMode, selectedMessage.severityLevel, rest, token);

  return popoverContent ? (
    <Popover placement="top" content={popoverContent}>
      {icon}
    </Popover>
  ) : (
    icon
  );
});
